import { observable, computed, action, extendObservable, useStrict, autorun, set } from "mobx";

const axios = require('axios');
const server_url = process.env.NODE_ENV === 'production' ? 'http://rhizo.de' : 'http://shoppr.local';


class Product {
	product_id = undefined
	@observable name       = undefined 
	@observable needs      = 0
	@observable prices     = {}
	
	constructor(product_id, name, needs = 0) {
		this.product_id = product_id
		this.name       = name
		this.needs      = parseInt(needs)
		this.prices     = {}
	}
}

class Store {
	store_id          = undefined
	@observable name  = undefined 
	
	constructor(store_id, name) {
		this.store_id   = store_id
		this.name       = name
	}
}

export default class Core {
	
	constructor() {
		this.ui = {
			shoppingListType: 'shopping-list',
		}
	}		
	
	@observable pod_id:   undefined
	@observable pod_name: undefined

	@observable ui
	
	@observable
	products = []
	
	@observable
	stores = []
	
	listTypes = {
		'shopping-list': 'Shopping List',
		'missing-prices': 'Missing Prices',
		'strict-shopping': 'Strict Shopping',
		'show-all': 'All',
	}	
	
	unique_seed = this.unique_id()
	client_id   = this.uuid('c')
	
	lastSync = {
		n: false,
	}
	
	@observable
	syncQueue   = []
	
	@observable
	productFilter = ''
	
	@action updateProductFilter(val) {
		this.productFilter = val
	}
	
	@action setShoppingListType(type) {
		this.ui.shoppingListType = type
	}
	
	@computed get storesShoppableProductsMatrix() {
		const matrix = {}
		
		this.stores.map( store => {
			
			const shoppableProducts = this.products.filter(product => {
				if (!product.needs) return false
				
				var min_price = 9999;			
				Object.keys(product.prices).map(key => {
					const price = product.prices[key]
					if (price) min_price = Math.min(min_price, price)
				})
				
				if (product.prices[store.store_id] == min_price) return true
				
				return false
			})
		
			matrix[store.store_id] = shoppableProducts
		})
		
		return matrix
	}
	
	@action action(op) {
		
		if (!op.log_id) op.log_id = this.uuid('l')	
		
		switch(op.op) {
			
			case 'addPod': {
				this.pod_id   = op.pod_id
				this.pod_name = op.name
				this.products = []
				this.stores   = []
				setTimeout(this.trySync.bind(this), 100)
				}
				break;
			
			case 'addProduct': {
					const product = new Product(op.product_id, op.name, op.needs ? op.needs : 0)
					this.products.push(product)
				}
				break;

			case 'updateProduct': {
					const product = this.products.find(p => p.product_id == op.product_id)
					if (product) {
						product.name = op.name
					}
				}
				break;
				
			case 'deleteProduct': {
					const i = this.products.findIndex(s => s.product_id == op.product_id)
					if (i >= 0) {
						this.products.splice(i, 1)	
					}
				}
				break;

			case 'addStore': {
					const store = new Store(op.store_id, op.name)
					this.stores.push(store)
				}
				break;
			
			case 'updateStore': {
					const store = this.stores.find(s => s.store_id == op.store_id)
					if (store) {
						store.name = op.name
					}
				}
				break;
			
			case 'deleteStore': {
					const i = this.stores.findIndex(s => s.store_id == op.store_id)
					if (i >= 0) {
						this.products.map( (p) => {
							for(var i=p.prices.length-1; i>=0; i--) { 
								if (p.prices[i].store_id == op.store_id) p.prices.splice(i, 1) 
							}
						})
						this.stores.splice(i, 1)
					}
				}
				break;
			
			case 'setPrice': {
					this.products.find(p => p.product_id == op.product_id).prices[op.store_id] = parseFloat(op.price)
				}
				break;
			
			case 'setNeeds': {
					this.products.find(p => p.product_id == op.product_id).needs = Math.max(0, op.needs)
				}
				break;
			
			default:
				console.error('Unknown OP ' + op.op);
		}
		
		if (op.synced) {
			// operation has already been synced (e.g. because it came FROM the server
		}
		else {
			this.syncQueue.push(op)
		}
	}
	
	@action loadPod(pod_id) {
			
			axios.post(server_url + '/server.php', { 'op': 'get_all', 'pod_id':pod_id})
				.then((response) => {
					// handle success
					const res = response.data;
					if (res.status.value == 200) {
						
						this.pod_id   = res.data.pod_id
						this.pod_name = res.data.name
						this.lastSync = res.data.lastSync
						
						res.data.stores.map(store => {
							this.action({ 'synced': true, op:'addStore', store_id: store.store_id, name: store.name })
						})
						
						res.data.products.map(product => {
							this.action({ 'synced': true, op:'addProduct', product_id: product.product_id, name: product.name, needs: product.needs })
							if (typeof product.prices !== 'undefined') product.prices.map((price) => {
								this.action({ 'synced': true, op:'setPrice', store_id: price.store_id, product_id: product.product_id, price: price.price })
							})
						})
						
					}
				})
				.catch(function (error) {
					// handle error
					console.log(error);
				})
				.finally(() => {
					// always executed
					setTimeout(this.trySync.bind(this), 2000)
				});
	}
	
	trySync() {
		
		const chunk = this.syncQueue.filter(o => !o.synced)
		
		if (chunk.length) {
			
			// console.log('Try to sync ' + chunk.length + ' ops')
			
			if (this.syncQueue.filter(o => o.synced == 'syncing').length) {
				console.warn('Sync in progress; delay/abort')
				return;
			}

			chunk.map(o => o.synced = 'syncing')

			axios.post(server_url + '/server.php', { 'op': 'commit', 'client_id': this.client_id, 'pod_id':this.pod_id , 'syncQueue': chunk})
				.then((response) => {
					// handle success
					const res = response.data;
					if (res.status.value == 200) {
						res.done.map(log_id => this.syncQueue.find(l => l.log_id == log_id).synced = 'synced')
						for(var i=this.syncQueue.length-1; i>=0; i--) {
							if (this.syncQueue[i].synced === 'synced') this.syncQueue.splice(i, 1);
						}
					}
				})
				.catch((error) => {
					// handle error
					this.syncQueue.map(o => { if (o.synced = 'syncing') o.synced = undefined} )
					console.error(error);
				})
				.finally(() => {
					// always executed
					setTimeout(this.trySync.bind(this), 2000)
				});			
		}
		else {
			// console.log('query for remote changes?', this.lastSync.n);
			
			axios.post(server_url + '/server.php', { 'op': 'upd', 'client_id': this.client_id, 'pod_id':this.pod_id , lastSync_n: this.lastSync.n})
				.then((response) => {
					// handle success
					const res = response.data;
					if (res.status.value == 200) {
						if ((typeof res.updates !== 'undefined') && (res.updates.length)) res.updates.map(op => {
							this.lastSync.n = op.n
							op.synced       = true
							this.action(op)
						})
					}
				})
				.catch((error) => {
					// handle error
					console.error(error);
				})
				.finally(() => {
					// always executed
					setTimeout(this.trySync.bind(this), 10000)
				});

		}
	}
	
	
	unique_id() {
		return (Math.random().toString(36)).substr(2,8);
	}

	
	uuid(prefix) {
		return prefix + '-' + this.unique_seed + '-' + this.unique_id();
	}

	
}